import { createSelector } from "reselect";

import { listToIndexMap } from "../../utils/immutableExtensions";
import { uiStateSelectors } from "../uiState";

const getItemSequenceIndex = (state, itemId) => state.data.sequence.indexOf(itemId);

const getItemSequence = state => state.data.sequence;

const getSequenceIndexById = createSelector(
  // Inputs
  sequence => sequence,
  // Output
  listToIndexMap
);

const getSequenceIndexByIdFromState = state => getSequenceIndexById(getItemSequence(state));

const getSelectedSequenceIndex = state =>
  uiStateSelectors.getSelectedItems(state).map(id => getItemSequenceIndex(state, id));

const getSelectedItemSequences = state => {
  const selectedItems = uiStateSelectors.getSelectedItems(state);
  const itemSequences = selectedItems.map(si => {
    return {
      id: si,
      sequenceIndex: getItemSequenceIndex(state, si)
    };
  });
  return itemSequences;
};

export default {
  getItemSequenceIndex,
  getItemSequence,
  getSequenceIndexById,
  getSequenceIndexByIdFromState,
  getSelectedSequenceIndex,
  getSelectedItemSequences
};
